<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ChangeLogDataProvider',
    props: {
        processId: {
            type: String,
            default: '0',
		},
	},
	computed: mapGetters('processes', {
		changeLogEntries: 'changeLogEntries',
	}),
	methods: {
        create({message, id, date, notify}) {
            this.$store.dispatch('processes/createChangeLogEntity', {
				message: message,
				date: date,
				id: this.processId,
				notify: notify,
            });
		}
	},
	render () {
		if (!this.$scopedSlots.default) {
			return;
		}

		const slotScope = {
			changeLogEntries: this.changeLogEntries,
			create: this.create
		};
		
		return this.$scopedSlots.default(slotScope);
	},
	beforeMount() {
		this.$store.dispatch('processes/fetchChangeLog', { 
			id: this.processId, 
		}).then(() => { this.success = true; });	
	}
}
</script>